import { createAction } from 'redux-actions'
import { fetchWorkspace } from 'actions'
import { getWorkspace } from 'selectors'
import boot from 'lib/boot'

export const BOOTED_APPLICATION = 'BOOTED_APPLICATION'
const bootedApplication = createAction(BOOTED_APPLICATION)

export function bootApplication (workspaceSlug) {
  return function (dispatch, getState) {
    dispatch(setActiveWorkspaceSlug(workspaceSlug))
    dispatch(fetchWorkspace(workspaceSlug)).then(() => {
      const workspace = getWorkspace(getState(), workspaceSlug) || {}
      boot(workspace.id).then(() => {
        dispatch(bootedApplication())
      })
    })
  }
}

export const SET_ACTIVE_WORKSPACE_SLUG = 'SET_ACTIVE_WORKSPACE_SLUG'

export const setActiveWorkspaceSlug = createAction(SET_ACTIVE_WORKSPACE_SLUG)



// WEBPACK FOOTER //
// ./actions/boot.js